import { prependRoot } from "./prependRoot.js";
import { getState } from "../store/configureStore";
import { getHistory } from '../util/configureHistory';

const redirector = {
	goTo: function (path, stateParam) {
		const destination = prependRoot(path, getState().settings.siteRoot);
		if (window.location.pathname !== destination)
			if (stateParam)
				getHistory().push(
					{
						pathname: destination,
						state: { param: stateParam }
					});
			else
				getHistory().push(destination);
	},
	goToHome: function () {
		redirector.goTo("/");
	},
	goBackInParentWindow: function () {
		redirector.goTo("/parentHistory/back");
	},
	goToPathInParentWindow: function (path) {
		if (path[0] == '/')
			path = path.substring(1);

		redirector.goTo("/parentHistory/path", path);
	}
};

export default redirector;
